"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFloatingLinkInsertState = exports.useFloatingLinkInsert = void 0;
var _react = _interopRequireDefault(require("react"));
var _plateCommon = require("@udecode/plate-common");
var _index = require("../forks/floating/index");
var _slateReact = require("slate-react");
var _useFloatingLinkEscape = require("./useFloatingLinkEscape");
var _useVirtualFloatingLink = require("./useVirtualFloatingLink");
var _plateLink = require("@udecode/plate-link");
var useFloatingLinkInsertState = function useFloatingLinkInsertState() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    floatingOptions = _ref2.floatingOptions;
  var editor = (0, _plateCommon.useEditorRef)();
  var _ref3 = (0, _plateCommon.getPluginOptions)(editor, _plateLink.ELEMENT_LINK),
    triggerFloatingLinkHotkeys = _ref3.triggerFloatingLinkHotkeys;
  var readOnly = (0, _plateCommon.useEditorReadOnly)();
  var focused = (0, _slateReact.useFocused)();
  var mode = (0, _plateLink.useFloatingLinkSelectors)().mode();
  var isOpen = (0, _plateLink.useFloatingLinkSelectors)().isOpen(editor.id);
  var floating = (0, _useVirtualFloatingLink.useVirtualFloatingLink)(_objectSpread({
    editorId: editor.id,
    getBoundingClientRect: _index.getSelectionBoundingClientRect,
    open: isOpen && mode === 'insert',
    whileElementsMounted: function whileElementsMounted() {}
  }, floatingOptions));
  return {
    editor: editor,
    floating: floating,
    focused: focused,
    isOpen: isOpen,
    readOnly: readOnly,
    triggerFloatingLinkHotkeys: triggerFloatingLinkHotkeys
  };
};
exports.useFloatingLinkInsertState = useFloatingLinkInsertState;
var useFloatingLinkInsert = function useFloatingLinkInsert(_ref) {
  var editor = _ref.editor,
    floating = _ref.floating,
    focused = _ref.focused,
    isOpen = _ref.isOpen,
    readOnly = _ref.readOnly,
    triggerFloatingLinkHotkeys = _ref.triggerFloatingLinkHotkeys;
  var onChange = _react.default.useCallback(function (e) {
    _plateLink.floatingLinkActions.text(e.target.value);
  }, []);
  var ref = (0, _plateCommon.useOnClickOutside)(function () {
    if (_plateLink.floatingLinkSelectors.mode() === 'insert') {
      _plateLink.floatingLinkActions.hide();
      (0, _plateCommon.focusEditor)(editor, editor.selection);
    }
  }, {
    disabled: !isOpen
  });

  // wait for update before focusing input
  _react.default.useEffect(function () {
    if (isOpen) {
      floating.update();
      _plateLink.floatingLinkActions.updated(true);
    } else {
      _plateLink.floatingLinkActions.updated(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, floating.update]);
  (0, _plateCommon.useHotkeys)(triggerFloatingLinkHotkeys, function (e) {
    if ((0, _plateLink.triggerFloatingLinkInsert)(editor, {
      focused: focused
    })) {
      e.preventDefault();
    }
  }, {
    enableOnContentEditable: true
  }, [focused]);
  (0, _useFloatingLinkEscape.useFloatingLinkEscape)();
  var updated = _plateLink.floatingLinkSelectors.updated();
  var updatedValue = _react.default.useCallback(function (el) {
    if (el && updated) {
      el.value = _plateLink.floatingLinkSelectors.text();
    }
  }, [updated]);
  return {
    hidden: readOnly,
    props: {
      style: _objectSpread({}, floating.style, {
        zIndex: 5000
      })
    },
    ref: (0, _plateCommon.useComposedRef)(floating.refs.setFloating, ref),
    textInputProps: {
      defaultValue: _plateLink.floatingLinkSelectors.text(),
      onChange: onChange,
      ref: updatedValue
    }
  };
};
exports.useFloatingLinkInsert = useFloatingLinkInsert;